import React from 'react';

import InstructorRoleProvider from 'contexts/instructorRole';
import StudentRoleProvider from 'contexts/studentRole';

const withRoleProviders = ({ children, auth }) => {
    if (auth?.role === 'admin') return <> {children} </>;
    return auth?.role === 'student' ? (
        <StudentRoleProvider>{children}</StudentRoleProvider>
    ) : (
        <InstructorRoleProvider>{children}</InstructorRoleProvider>
    );
};

export default withRoleProviders;
